// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + "ce9ad0ff0d5f41ae4dc3" + ".min.js";
};